module.exports = __webpack_public_path__ + "media/images/bitmap/payment-success-img-0cfaa83392586b146f592971f4e53f1c.svg";